import { Component, OnInit, OnDestroy, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { AppInitializerService } from "./core/services/app-initializer.service";
import { NgApexchartsModule } from "ng-apexcharts";
import { InactivityService } from "./core/services/InactivityService";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, MatProgressSpinnerModule, NgApexchartsModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit, OnDestroy {
  title = "ares-client";
  public init = inject(AppInitializerService);
  private inactivityService = inject(InactivityService);

  ngOnInit(): void {
    // Start monitoring user inactivity
    this.inactivityService.startMonitoring();

    // Existing splash screen logic
    setTimeout(() => {
      const splash = document.getElementById("app-init-splash");
      if (splash) splash.remove();
    }, 10);
  }

  ngOnDestroy(): void {
    // Stop monitoring user inactivity
    this.inactivityService.stopMonitoring();
  }
}
